/* @flow strict */

import React from 'react';
import { format } from '/client/src/utils/amountTransformation';
import { currency } from '/client/src/constants/';
import moment from 'moment';

export const columns = (context): [] => {
  return ([
    {
      selector: 'name',
      name: 'Name',
      sortable: true,
      style: {
        minWidth: '200px',
        padding: '10px 16px'
      },
      cell: (row: {}): string =>  row.name
    },
    {
      selector: 'email',
      name: 'email',
      sortable: true,
      style: {
        minWidth: '200px',
        padding: '10px 16px'
      },
      cell: (row: {}): string =>  row.email
    },
    {
      selector: 'reffered_date',
      name: 'date reffered',
      sortable: true,
      style: {
        minWidth: '200px',
        padding: '10px 16px'
      },
      cell: (row: {}): string => {
        if (moment(row.reffered_date).isValid()) {
          return moment(row.reffered_date).format('MM/DD/YYYY hh:mm a z');
        }

        return '-';
      }
    },
    {
      selector: 'created_date',
      name: 'account created',
      sortable: true,
      style: {
        minWidth: '200px',
        padding: '10px 16px'
      },
      cell: (row: {}): string => {
        if (moment(row.created_date).isValid()) {
          return moment(row.created_date).format('MM/DD/YYYY hh:mm a z');
        }

        return '-';
      }
    },
    {
      selector: 'payout',
      name: 'payout',
      sortable: true,
      style: {
        minWidth: '200px',
        padding: '10px 16px'
      },
      cell: (row: {}): string => format(currency[`${context.profileCurrent.currency}`], row.payout, false, true)
    }
  ]);
};
